import { io } from "socket.io-client";
import API from "./api";

export default class WS {
    socket = null;
    static instance;

    constructor(){
        WS.instance = this;
    }

    init() {
        this.socket = io(API.uri, {auth: {token: API.token}});
        return new Promise(resolve => {
            this.socket.on('connect', () => { console.log(`WS connected to server! Id: ${this.socket.id}`); resolve(); });
            this.socket.on('disconnect', reason => { console.log(`WS has diconnected: ${reason}`); })
            this.socket.on('reconnect', () => { console.log(`WS reconnected!`); });
            this.socket.on('reconnecting', () => { console.log(`WS reconnecting...`); });
        })
        
    }

    static listen(event, callback) {
        if (!WS.instance.socket) return () => {};
        WS.instance.socket.on(event, callback);

        return () => {
            WS.instance.socket.off(event, callback);
        }
    }

    static unlisten(event, callback) {
        if (!WS.instance.socket) return;
        WS.instance.socket.off(event, callback);
    }

    static emit(event, data){
        if (!WS.instance.socket) return;
        WS.instance.socket.emit(event, data);
    }

    static initialized() {
        return WS.instance.socket;
    }

    static id(){
        return WS.instance?.socket?.id;
    }

    static disconnectListener(callback){
        WS.listen('disconnect', callback);
        return () => {
            WS.unlisten('disconnect', callback);
        }
    }

    static dataListener(props){
        const { groupId, locationId, machineId, onJoin, onClose, onUpdate } = props;
        WS.emit('data', {groupId, locationId, machineId});
        const name = machineId ? 'machine' : (locationId ? 'location' : 'group'),
            id = machineId ?? (locationId ?? groupId);
        
        if (props?.onJoin) WS.listen(`${name}_join`, onJoin);
        if (props?.onClose) WS.listen(`${name}_close`, onClose);
        if (props?.onUpdate) WS.listen(`${name}_update`, onUpdate);

        return () => {
            WS.emit('data_leave', {groupId, locationId, machineId});
            if (props?.onJoin) WS.unlisten(`${name}_join`, onJoin);
            if (props?.onClose) WS.unlisten(`${name}_close`, onClose);
            if (props?.onUpdate) WS.unlisten(`${name}_update`, onUpdate);
        }
    }

    static reportListener(props){
        const { id, onJoin, onClose, onDone } = props;
        WS.emit('report', {id: id});
        if (onJoin) WS.listen(`report_join_${id}`, props.onJoin);
        if (onClose) WS.listen(`report_close_${id}`, props.onClose);
        if (onDone) WS.listen(`report_done_${id}`, props.onDone);

        return () => {
            WS.emit('report_leave', {id: props.id});
            if (onJoin) WS.unlisten(`report_join_${props.id}`, props.onJoin);
            if (onClose) WS.unlisten(`report_close_${props.id}`, props.onClose);
            if (onDone) WS.unlisten(`report_done_${props.id}`, props.onDone);
        }
    }

    static eventsListener(props){
        const { groupId, locationId, machineId, language, onJoin, onClose, onNew, types } = props;
        WS.emit('events', {groupId, locationId, machineId, language, types});

        const name = machineId ? 'machine' : (locationId ? 'location' : 'group'),
            id = machineId ?? (locationId ?? groupId);
        
        if (onJoin) WS.listen(`events_${name}_${id}_join`, onJoin);
        if (onClose) WS.listen(`events_${name}_${id}_close`, onClose);
        if (onNew) WS.listen(`events_${name}_${id}_new`, onNew);

        return () => {
            WS.emit('events_leave', {groupId, locationId, machineId});
            if (onJoin) WS.unlisten(`events_${name}_${id}_join`, onJoin);
            if (onClose) WS.unlisten(`events_${name}_${id}_close`, onClose);
            if (onNew) WS.unlisten(`events_${name}_${id}_new`, onNew);
        }
    }

    static advancedSettingsListener(props){
        const { groupId, locationId, machineId, onJoin, onClose, onWrite, onRead, onMachineReset } = props;
        WS.emit('advanced_settings', {groupId, locationId, machineId});

        if (onJoin) WS.listen('advanced_settings_join', onJoin);
        if (onClose) WS.listen('advanced_settings_close', onClose);
        if (onWrite) WS.listen('advanced_settings_write', onWrite);
        if (onRead) WS.listen('advanced_settings_read', onRead);
        if (onMachineReset) WS.listen('advanced_settings_reset', onMachineReset);

        return () => {
            WS.emit('advanced_settings_leave', {groupId, locationId, machineId});
            if (onJoin) WS.unlisten('advanced_settings_join', onJoin);
            if (onClose) WS.unlisten('advanced_settings_close', onClose);
            if (onWrite) WS.unlisten('advanced_settings_write', onWrite);
            if (onRead) WS.unlisten('advanced_settings_read', onRead);
            if (onMachineReset) WS.unlisten('advanced_settings_reset', onMachineReset);
        }
    }

    static devListener(props){
        const { onJoin, onLog, onAppError, onAppErrorRemoved, onClose } = props;
        WS.emit('dev');

        if (onJoin) WS.listen('dev_join', onJoin);
        if (onClose) WS.listen('dev_close', onClose);
        if (onLog) WS.listen('dev_log', onLog);
        if (onAppError) WS.listen('dev_apperror', onAppError);
        if (onAppErrorRemoved) WS.listen('dev_apperror_removed', onAppErrorRemoved);

        return () => {
            WS.emit('dev_leave');
            if (onJoin) WS.unlisten('dev_join', onJoin);
            if (onClose) WS.unlisten('dev_close', onClose);
            if (onLog) WS.unlisten('dev_log', onLog);
            if (onAppError) WS.unlisten('dev_apperror', onAppError);
            if (onAppErrorRemoved) WS.unlisten('dev_apperror_removed', onAppErrorRemoved);
        }
    }
}